import { render } from "./Particles.vue?vue&type=template&id=482918b0&scoped=true"
import script from "./Particles.vue?vue&type=script&lang=js"
export * from "./Particles.vue?vue&type=script&lang=js"

import "./Particles.vue?vue&type=style&index=0&id=482918b0&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-482918b0"]])

export default __exports__